import { useRef, useState } from "react";
import { api } from "../lib/api";
import { UploadSimple, Trash, ImageSquare } from "@phosphor-icons/react";

/**
 * Generic image uploader. Posts multipart to `endpoint`.
 * onUploaded(url) fires after success.
 */
export default function ImageUpload({ endpoint, currentUrl, onUploaded, size = 80, testid = "image-upload", round = true, label = "Upload image" }) {
  const ref = useRef(null);
  const [uploading, setUploading] = useState(false);
  const [err, setErr] = useState("");

  const handle = async (e) => {
    const f = e.target.files?.[0];
    if (!f) return;
    setErr("");
    if (f.size > 10 * 1024 * 1024) { setErr("File too large (max 10MB)"); return; }
    setUploading(true);
    try {
      const fd = new FormData();
      fd.append("file", f);
      const r = await api.post(endpoint, fd, { headers: { "Content-Type": "multipart/form-data" } });
      onUploaded?.(r.data.url);
    } catch (ex) {
      setErr(ex?.response?.data?.detail || "Upload failed");
    }
    setUploading(false);
    if (ref.current) ref.current.value = "";
  };

  return (
    <div className="inline-flex items-center gap-3" data-testid={testid}>
      <div
        className={`flex items-center justify-center bg-secondary border border-border overflow-hidden ${round ? "rounded-full" : ""}`}
        style={{ width: size, height: size }}
      >
        {currentUrl ? (
          <img src={currentUrl} alt="" className="w-full h-full object-cover" />
        ) : (
          <ImageSquare size={size * 0.45} weight="thin" className="text-muted-foreground" />
        )}
      </div>
      <div>
        <input ref={ref} type="file" accept="image/*" onChange={handle} className="hidden" data-testid={`${testid}-input`} />
        <button className="btn btn-secondary btn-sm" onClick={() => ref.current?.click()} disabled={uploading} data-testid={`${testid}-btn`}>
          <UploadSimple size={12} /> {uploading ? "UPLOADING..." : label.toUpperCase()}
        </button>
        {err && <div className="text-xs text-destructive mt-1" data-testid={`${testid}-error`}>{err}</div>}
      </div>
    </div>
  );
}
